import { Box, Header } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const HeaderContainer = Box.withConfig({
  marginTop: '$5',
  marginBottom: '$4',
  justifyContent: 'center',
  alignItems: 'center',
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
});

export const HeaderStyled = Header.withConfig({
  variant: 'hero',
  textAlign: 'center',
  color: theme.token('text-hero-light'),
  fontWeight: 700,
  margin: 0,
  noOfLines: 1,
  _web: {
    width: '100vw',
  },
});

export const FooterContainer = Box.withConfig({
  width: 'full',
  paddingX: '$4',
  position: 'relative',
  bottom: 2,
});

export const HeroSection = Box.withConfig({
  background: 'transparent',
});
